 <div class="container">
 <mat-card class="militar-info">
    <h2>Dados do Militar</h2>
    <div class="info-column">
      <span><strong>Matrícula:</strong> {{ beneficiario.matricula }}</span>
      <span><strong>Nome:</strong> {{ beneficiario.nome }}</span>
      <span><strong>ID Funcional:</strong> {{ beneficiario.idFuncional }}</span>
      <span><strong>CPF:</strong> {{ beneficiario.cpf }}</span>
      <span><strong>Órgão:</strong> {{ beneficiario.orgao.sigla }}</span>
    </div>
  </mat-card>

<app-etapas-beneficio
  [etapaSelecionada]="3"
  >
</app-etapas-beneficio>

<mat-card class="afastamento-card">
  <h2>Afastamento</h2>

  <form [formGroup]="form" (ngSubmit)="enviar()" class="form-grid">
  <div class="form-row">
    <mat-form-field appearance="outline">
      <mat-label>Data de Afastamento</mat-label>
      <input matInput
             [matDatepicker]="picker1"
             formControlName="dataAfastamento"
             placeholder="dd/mm/aaaa"
             (input)="onDateInput($event, 'dataAfastamento')" />
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
      <mat-hint>Digite dd/mm/aaaa ou use o calendário</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Data do Diário Oficial</mat-label>
      <input matInput
             [matDatepicker]="picker2"
             formControlName="dataDO"
             placeholder="dd/mm/aaaa"
             (input)="onDateInput($event, 'dataDO')" />
      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
      <mat-hint>Digite dd/mm/aaaa ou use o calendário</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Página do DO</mat-label>
      <input matInput type="number" formControlName="paginaDO" />
    </mat-form-field>
  </div>

  <div class="form-row full-width">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Observação</mat-label>
      <textarea matInput formControlName="observacao" rows="3"></textarea>
    </mat-form-field>
  </div>

  <div class="actions">
    <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid || enviando">
      Enviar
    </button>
  </div>
</form>
<mat-card class="dados-afastamento" *ngIf="afastamentoCadastrado">
  <h3>Dados do Afastamento Cadastrado</h3>

  <div class="info-grid">
    <div><strong>Nome:</strong> {{ afastamentoCadastrado.nome || 'Não informado' }}</div>
    <div><strong>Matrícula:</strong> {{ afastamentoCadastrado.matricula || 'Não informado' }}</div>
    <div><strong>Órgão:</strong> {{ afastamentoCadastrado.orgao || 'Não informado' }}</div>
    <div><strong>Data do Requerimento:</strong>
      {{ afastamentoCadastrado.dadosRequerimento?.dataRequerimento ? (afastamentoCadastrado.dadosRequerimento.dataRequerimento | date:'dd/MM/yyyy') : 'Não informado' }}
    </div>
    <div><strong>Data de Afastamento:</strong>
      {{ afastamentoCadastrado.dadosAfastamento?.dataAfastamento ? (afastamentoCadastrado.dadosAfastamento.dataAfastamento | date:'dd/MM/yyyy') : 'Não informado' }}
    </div>
    <div><strong>Tipo de Afastamento:</strong> {{ afastamentoCadastrado.dadosAfastamento?.tipoAfastamento || 'Não informado' }}</div>
    <div><strong>Situação na Folha:</strong> {{ afastamentoCadastrado.dadosAfastamento?.situacaoFolhaPagamento || 'Não informado' }}</div>
    <div><strong>Código da Folha:</strong> {{ afastamentoCadastrado.dadosFolhaPagamento?.codigo || 'Não informado' }}</div>
    <div><strong>Data na Folha:</strong>
      {{ afastamentoCadastrado.dadosFolhaPagamento?.dataAfastamento ? (afastamentoCadastrado.dadosFolhaPagamento.dataAfastamento | date:'dd/MM/yyyy') : 'Não informado' }}
    </div>
  </div>
</mat-card>
</mat-card>
</div>
